module.exports = __webpack_public_path__ + "img/folder-open.71ac2800.svg";